import React, {useEffect, useRef, useState} from 'react';
import {IoMdCheckmarkCircle, IoMdCloseCircle} from 'react-icons/io';
import {useUpdateActiveClientSubscriptionLookup} from '../../processes/client_subscription_active';


export default function EditStatusDialog({subscription, onClose, onSuccess}) {
    const dialogRef = useRef(null);
    const [status, setStatus] = useState(subscription.isActive === 1 ? 'active' : 'inactive');
    const {mutate, isPending, isSuccess, isError, error} = useUpdateActiveClientSubscriptionLookup();


    useEffect(() => {
        if (dialogRef.current) dialogRef.current.showModal();
        if (subscription) setStatus(subscription.isActive === 1 ? 'active' : 'inactive');
    }, [subscription]);


    useEffect(() => {
        if (isSuccess) {
            dialogRef.current?.close();
            onSuccess?.();
        }
    }, [isSuccess, onSuccess]);


    const save = (e) => {
        e?.preventDefault?.();
        mutate({subscriptionId: subscription.id, isActive: status === 'active' ? 1 : 0});
    };


    return (
        <dialog ref={dialogRef} className="tw-modal tw-modal-middle" onClose={onClose}>
            <div className="tw-modal-box tw-w-11/12 tw-max-w-md">
                <div className="tw-bg-primary tw-text-primary-content tw-p-4 tw-rounded-t-lg tw--m-6 tw-mb-6">
                    <h3 className="tw-font-bold tw-text-lg">Update Subscription Status</h3>
                </div>


                {isError && (
                    <div className="tw-alert tw-alert-error tw-mb-4">
                        <span>{error?.message || 'Failed to update subscription'}</span>
                    </div>
                )}


                <div className="tw-space-y-4">
                    <div className="tw-form-control">
                        <label className="tw-label"><span className="tw-label-text">Client</span></label>
                        <input className="tw-input tw-input-bordered tw-bg-base-200"
                               value={subscription.client?.name || 'N/A'} disabled/>
                    </div>


                    <div className="tw-form-control">
                        <label className="tw-label"><span className="tw-label-text">Subscription ID</span></label>
                        <input className="tw-input tw-input-bordered tw-bg-base-200" value={subscription.id} disabled/>
                    </div>


                    <div className="tw-form-control">
                        <label className="tw-label"><span className="tw-label-text">New Status</span></label>
                        <div className="tw-flex tw-space-x-4">
                            <label className="tw-label tw-cursor-pointer tw-flex tw-items-center tw-space-x-2">
                                <input type="radio" name="status" className="tw-radio tw-radio-success" value="active"
                                       checked={status === 'active'} onChange={(e) => setStatus(e.target.value)}
                                       disabled={isPending}/>
                                <IoMdCheckmarkCircle style={{color: '#4CAF50', fontSize: 16}}/>
                                <span>Active</span>
                            </label>
                            <label className="tw-label tw-cursor-pointer tw-flex tw-items-center tw-space-x-2">
                                <input type="radio" name="status" className="tw-radio tw-radio-error" value="inactive"
                                       checked={status === 'inactive'} onChange={(e) => setStatus(e.target.value)}
                                       disabled={isPending}/>
                                <IoMdCloseCircle style={{color: '#F44336', fontSize: 16}}/>
                                <span>Inactive</span>
                            </label>
                        </div>
                    </div>


                    <div className="tw-flex tw-space-x-3 tw-pt-4">
                        <button className="tw-btn tw-btn-outline tw-flex-1" onClick={onClose}
                                disabled={isPending}>Cancel
                        </button>
                        <button className="tw-btn tw-btn-primary tw-flex-1" onClick={save}
                                disabled={isPending || !status || status === (subscription.isActive === 1 ? 'active' : 'inactive')}>
                            {isPending ? (<><span
                                className="tw-loading tw-loading-spinner tw-loading-sm"/>Saving...</>) : 'Save'}
                        </button>
                    </div>
                </div>
            </div>
            <div className="tw-modal-backdrop" onClick={onClose}/>
        </dialog>
    );
}
